/* global themeVars */

/**
 * Class to toggle Contact Form 7 acceptance hidden text.
 * Truncates long acceptance text and provides a "show more / show less" toggle.
 */
export class Cf7AcceptanceToggle {

	/**
	 * Creates an instance of Cf7AcceptanceToggle.
	 * @param {string} [selector='.acceptance-hidden'] - CSS selector for hidden acceptance elements.
	 */
	constructor( selector = '.acceptance-hidden' ) {

		this.selector = selector;
		this.init();

	}

	/**
	 * Initializes the toggle functionality for all hidden acceptance spans.
	 */
	init() {

		if ( !document.querySelector( '.wpcf7' ) ) {

			return;

		}

		document.querySelectorAll( this.selector ).forEach( span => this.setup( span ) );

	}

	/**
	 * Returns button element for toggle.
	 * @param {string[]} [classes=[]] - Additional CSS classes to apply to the button.
	 * @return {HTMLButtonElement} The created button element.
	 */
	createToggleButton( classes = [] ) {

		const button = document.createElement( 'button' );
		button.type = 'button';
		button.classList.add( 'toggle-acceptance', ...classes );

		const span = document.createElement( 'span' );
		span.classList.add( 'toggle-text' );
		span.textContent = themeVars?.cf7?.showMore || 'Rozwiń';

		const svgWrapper = document.createElement( 'span' );
		svgWrapper.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M14 1.00174L12.9492 0L7.001 5.67168L1.05077 0L0 1.00174L5.95 6.67392L6.99484 7.68L14 1.00174Z" fill="currentColor"/>
		</svg>`;

		button.appendChild( span );
		button.appendChild( svgWrapper );

		return button;

	}

	/**
	 * Sets up a single hidden acceptance span with truncated text and toggle button.
	 * @param {HTMLElement} span - The acceptance element to enhance.
	 */
	setup( span ) {

		if ( span.closest( '.acceptance-wrapper' ) ) {

			return;

		}

		const wrapper = document.createElement( 'span' );
		wrapper.classList.add( 'acceptance-wrapper' );

		const parent = span.parentNode;
		parent.insertBefore( wrapper, span );
		wrapper.appendChild( span );

		const inlineBtn = this.createToggleButton( ['inline'] );
		span.appendChild( inlineBtn );

		const wrapperBtn = this.createToggleButton( ['wrapper'] );
		wrapper.appendChild( wrapperBtn );

		/**
		 * Toggle function for show wrapper and modify buttons.
		 */
		const toggle = () => {

			const isExpanded = span.classList.toggle( 'expanded' );

			inlineBtn.classList.toggle( 'expanded', isExpanded );
			wrapperBtn.classList.toggle( 'expanded', isExpanded );

			const text = isExpanded
				? themeVars?.cf7?.showLess || 'Zwiń'
				: themeVars?.cf7?.showMore || 'Rozwiń';

			inlineBtn.querySelector( '.toggle-text' ).textContent = text;
			wrapperBtn.querySelector( '.toggle-text' ).textContent = text;

		};

		inlineBtn.addEventListener( 'click', toggle );
		wrapperBtn.addEventListener( 'click', toggle );

	}

}
